/**
 * Ayuda — Productos → Artículos
 */

/** @type {import('../help-index.js').HelpSidebarItem} */
export const ADM_PRO_ARTICLES_ITEM = {
  id: 'articles',
  screenId: 'adm-pro-articles',
  label: 'Artículos',
  description: 'Ver, buscar y cargar productos.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro: 'Acá administrás los productos que comprás, vendés o controlás en stock.',
      },
      {
        title: 'Paso 1 — Buscar y filtrar',
        fields: [
          { label: 'Buscar', description: 'Escribí al menos 3 letras de código o descripción. Si borrás el texto, vuelve la lista completa.' },
          { label: 'Grupo de artículos', description: 'Filtrá por un grupo o dejá «Todos».' },
          { label: 'Comprado / Vendido / Estockeable', description: 'Activá cada interruptor para ver solo artículos con esa característica.' },
        ],
      },
      {
        title: 'Paso 2 — Leer la lista',
        bullets: [
          'Columnas: Código, Descripción, Grupo.',
          'Tocá una fila para ver la ficha del artículo.',
          'Tocá el lápiz para editar.',
        ],
      },
      {
        title: 'Paso 3 — Cargar un artículo nuevo',
        intro: 'El botón + abre «Nuevo artículo».',
      },
      {
        title: 'Datos principales',
        fields: [
          { label: 'Descripción', description: 'Nombre del producto. Obligatorio.' },
          { label: 'Código', description: 'Código interno o de barras propio.' },
          { label: 'EAN', description: 'Código de barras estándar (opcional).' },
          { label: 'Unidad', description: 'Unidad de medida (unidad, kg, litro, etc.).' },
          { label: 'Alícuota IVA', description: 'IVA que aplica al facturar (21 %, 10,5 %, etc.). Obligatorio.' },
          { label: 'Concepto de factura', description: 'Define cómo se trata impositivamente, si es un producto o un impuesto. Salvo que se traten de percepciones o algun tipo de impuesto se usada Neto Gravado.' },
          { label: 'Comprado / Vendido / Estockeable', description: 'Indicá si lo comprás, lo vendés y si lleva control de stock.' },
        ],
      },
      {
        title: 'Grupos, centros y cuentas',
        bullets: [
          'Grupos — marcá a qué grupos de artículos pertenece.',
          'Centro de costo — gasto asociado al producto (opcional).',
          'Centro de ingresos — ingreso asociado al producto (opcional).',
          'Cuentas contables — si usás contabilidad, podés vincular cuentas del plan.',
        ],
      },
      {
        title: 'Observaciones y guardar',
        intro: 'Notas internas opcionales. Tocá «Crear artículo» para guardar.',
      },
    ],
  },
}
